module.exports = __webpack_public_path__ + "img/Elderberry.1f071845.jpg";